import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

export async function fetchWorkOrderMaterialCandidates(listQuery) {
  const { data: raw } = await request.get('/mom/work-order/material-candidates', {
    params: listQueryToApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
